// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-empty-list .fi-items-list-no-more-items {
  margin: 40px auto 0;
  width: 100%;
  text-align: center;
  display: inline-block;
}
.fi-empty-list .fi-items-list-no-more-items.container-large-margin-top {
  margin-top: 96px;
}
.fi-empty-list .fi-items-list-no-more-items .no-more-items-icons {
  display: inline-block;
  line-height: 100px;
  position: relative;
}
.fi-empty-list .fi-items-list-no-more-items .no-more-items-icons span {
  position: absolute;
}
.fi-empty-list .fi-items-list-no-more-items .no-more-items-icons span.size75:before {
  font-size: 75px;
}
.fi-empty-list .fi-items-list-no-more-items .no-more-items-icons span.posCenter {
  position: inherit;
  vertical-align: middle;
}
.fi-empty-list .fi-items-list-no-more-items .no-more-items-header {
  font-size: 25px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}
.fi-empty-list .fi-items-list-no-more-items .no-more-items-text {
  font-size: 16px;
}
.fi-empty-list .fi-items-list-no-more-items .missing-items-description {
  color: var(--fi-color-steel-grey) !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  max-width: 632px;
  margin: 0 auto;
}
.fi-empty-list .fi-items-list-no-more-items .missing-items-icon.size80 {
  font-size: 80px;
  color: #C3C7CF;
  width: 120px;
  height: 120px;
  line-height: 120px;
  margin-bottom: 16px;
}
.fi-empty-list .fi-items-list-no-more-items.size-small {
  margin: 20px auto;
}
.fi-empty-list .fi-items-list-no-more-items.size-small .no-more-items-icons {
  line-height: unset;
  margin-top: 4px;
  margin-bottom: 4px;
}
.fi-empty-list .fi-items-list-no-more-items.size-small .no-more-items-icons span:before {
  font-size: 32px;
}
.fi-empty-list .fi-items-list-no-more-items.size-small .no-more-items-header {
  font-weight: 400;
  font-size: 14px;
  font-style: unset;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-empty-list/fi-empty-list.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AAAR;AAEQ;EACI,gBAAA;AAAZ;AAGQ;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;AADZ;AAGY;EACI,kBAAA;AADhB;AAEgB;EACI,eAAA;AAApB;AAGgB;EACI,iBAAA;EACA,sBAAA;AADpB;AAMQ;EACI,eAAA;EACA,iDAAA;AAJZ;AAOQ;EACI,eAAA;AALZ;AAQQ;EACI,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AANZ;AASY;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAPhB;AAWQ;EACI,iBAAA;AATZ;AAUY;EACI,kBAAA;EAIA,eAAA;EACA,kBAAA;AAXhB;AAOgB;EACI,eAAA;AALpB;AAWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAThB","sourcesContent":[".fi-empty-list {\r\n    .fi-items-list-no-more-items {\r\n        margin: 40px auto 0;\r\n        width: 100%;\r\n        text-align: center;\r\n        display: inline-block;\r\n\r\n        &.container-large-margin-top {\r\n            margin-top: 96px;\r\n        }\r\n\r\n        .no-more-items-icons {\r\n            display: inline-block;\r\n            line-height: 100px;\r\n            position: relative;\r\n\r\n            span {\r\n                position: absolute;\r\n                &.size75:before {\r\n                    font-size: 75px;\r\n                }\r\n\r\n                &.posCenter {\r\n                    position: inherit;\r\n                    vertical-align: middle;\r\n                }\r\n            }\r\n        }\r\n\r\n        .no-more-items-header {\r\n            font-size: 25px;\r\n            font-family: Roboto, 'Helvetica Neue', sans-serif;\r\n        }\r\n\r\n        .no-more-items-text {\r\n            font-size: 16px;\r\n        }\r\n\r\n        .missing-items-description {\r\n            color: var(--fi-color-steel-grey) !important;\r\n            text-align: center;\r\n            font-size: 16px;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: 24px;\r\n            letter-spacing: 0.5px;\r\n            max-width: 632px;\r\n            margin: 0 auto;\r\n        }\r\n        .missing-items-icon {\r\n            &.size80 {\r\n                font-size: 80px;\r\n                color: #C3C7CF;\r\n                width: 120px;\r\n                height: 120px;\r\n                line-height: 120px;\r\n                margin-bottom: 16px;\r\n            }\r\n        }\r\n\r\n        &.size-small {\r\n            margin: 20px auto;\r\n            .no-more-items-icons {\r\n                line-height: unset;\r\n                span:before {\r\n                    font-size: 32px;\r\n                }\r\n                margin-top: 4px;\r\n                margin-bottom: 4px;\r\n            }\r\n\r\n            .no-more-items-header {\r\n                font-weight: 400;\r\n                font-size: 14px;\r\n                font-style: unset;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
